const Map=()=>{
return(
   <iframe width="100%" height="250" id="gmap_canvas" src="https://maps.google.com/maps?q=goa&t=&z=13&ie=UTF8&iwloc=&output=embed"></iframe>
)
}

export default Map